import request from '@/Utilities/httpRequest.js';
import prozisEventQueue from "../../../../../../src-js/monitor-user-behaviour-2/prozis-event-queue.js";

export default {

  _url: null, 
  _urlDetail: null, 
  _timer: null,
  _channel: null,
  _rid: null,
  _error: false,
  _paused: false,
  _interval: null,

  init: function(interval, url, urlDetail){
	  if(interval && window.localStorage !== undefined){
      //console.log('MagicCartTimer: init', interval, typeof interval);
      //localStorage.setItem("mcInterval", interval);
      this._interval = interval;

      if(!url){
        const curUrl = new URL(window.location.href);
        const parts = curUrl.pathname.split('/');
        if(parts && parts.length > 2){
          this._url = '/' + parts[1] + '/' + parts[2] + '/magic-cart/new';
          this._urlDetail = '/' + parts[1] + '/' + parts[2] + '/magic-cart';
        }
        else if(window.location.port === '8080'){
          // vue development mode
          this._url = "https://"+window.location.hostname+"/pt/pt/magic-cart/new";
          this._urlDetail = "https://"+window.location.hostname+"/pt/pt/magic-cart";
        }
      }
      else{
        this._url = url;
        this._urlDetail = urlDetail;
      }

      if(!this._url){
        return ;
      }

      if(window.mub){
        this._rid = window.mub.rid;
      }

      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") {
          //console.log('McTimer visibilitychange -> visible')
          this.resume();
        } else {
          //console.log('McTimer visibilitychange -> !visible')
          this.pause();
        }
      });

      if(document.visibilityState === "visible"){
        this._init(interval);
      }
	  }
  },

  pause: function(){
    this._paused = true;
    //console.log('McTimer pause!!!')
    if(this._channel){
      this._channel.close();
      this._channel = null;
    }
    clearTimeout(this._timer);
  },

  resume: function(){
    this._paused = false;
    //console.log('McTimer resume!!!')
    //this._init(this._getStorageValInterval());
    this._init(this._interval);
  },

  loadPromos: async function(urlDetail) {
    const {data} = await request.get(urlDetail, {}, false);
    try{
        if(data && data.blocks && data.blocks.length){
            data.expire = Date.now() + (60 + 1000); // expired in 1 minute
            let promos = new Array();
            data.blocks.forEach(b => {
                promos.push(b.id);
            });
            prozisEventQueue.addEvent('magic-cart', 'loaded', {promos: promos}, true);
        }
        else{
            prozisEventQueue.addEvent('magic-cart', 'error', {error: 'noData'}, true);
        }
    }catch(e) {
        if (!(e instanceof Error)) {
            e = new Error(e);
        }                
        prozisEventQueue.addEvent('magic-cart', 'error', {error: 'UI error '+e.message}, true);
    }

    return data;
  },

  _init:function(interval){
    if(this._error){
      return;
    }

    if(window.BroadcastChannel){
      this._channel = new BroadcastChannel("prz_magic_cart");
      this._channel.addEventListener('message', (event) => {
        //console.info('MagicCartTimer: message received ', event.data);
        this._update(event.data);
      });
    } 
    
    this._update({interval: interval});
  },

  _update: async function(data){
    //console.log('MagicCartTimer: _update', data);
    clearTimeout(this._timer);

    if(data && data.hasOwnProperty('hasNewPromo')){
      // dispatch event to update
      let elem = document.getElementById('header-links');
      if(!elem){
        elem = document.getElementById('mobileNavBar');
      }

      if(elem){
        if(data.hasNewPromo || data.open){
          //console.log('MagicCartTimer: load promos');
          data.promos = await this.loadPromos(this._urlDetail);
        }

        //console.log('MagicCartTimer: dispatch event evtMagicCartNewPromo', data);
        const event = new CustomEvent("evtMagicCartNewPromo", { detail: data });
        elem.dispatchEvent(event);
      }
    }
    if(!this._paused){
      //console.log('MagicCartTimer: set timer again (_update)', data.interval);
      this._interval = data.interval ? data.interval : this._interval;
      this._timer = setTimeout(() => {this._checkPromos()}, this._interval);
    }
  },

  _checkPromos: async function(){
    //console.log('MagicCartTimer: _checkPromos')    
    let mcInterval = this._interval; //this._getStorageValInterval();
    //console.log('MagicCartTimer: mcInterval', mcInterval);
    if(!mcInterval){
      //console.log('MagicCartTimer: no interval, exit')
      return;
    }

    const timestamp = new Date().getTime();
    const mcRequest = parseInt(localStorage.getItem("mcRequest"));
    //console.log('mcRequest + mcInterval < timestamp', mcRequest, mcInterval , timestamp, mcRequest + mcInterval < timestamp)
    if(!mcRequest || (mcRequest + mcInterval < timestamp)){
      //console.info('MagicCartTimer: do request')  
      // use local storage to tel other tabs that request in being done
      localStorage.setItem("mcRequest", timestamp);
      
      // do request
      const {data} = await request.get(this._url, {}, false);
      //console.log('MagicCartTimer: response data', data);
      if(data && data.hasOwnProperty('hasNewPromo')){
        //console.log('MagicCartTimer: valid data');
        mcInterval = data.interval;
        //localStorage.setItem("mcInterval", mcInterval);
        this._interval = data.interval;
        if(this._channel){
          //console.log('MagicCartTimer: broadcast message');
          this._channel.postMessage(data);
          // update current tab (BroadcastChannel does not send message to itself)
          this._update(data);
        }
        else if(!this._paused){
          //console.log('MagicCartTimer: set timer again (_checkPromos)', mcInterval);
          this._timer = setTimeout(() => {this._checkPromos()}, parseInt(mcInterval));
        }
      }

      // remove item from local storage
      localStorage.removeItem('mcRequest');
    }
  },
  
//   _getData: async function() {
//     let json = null;

//     if(!this._url){
//       //console.log('MagicCartTimer _getData: URL is null');
//       return json;
//     }

//     try {
//       // Default options are marked with *
//       const response = await fetch(this._url, {
//         method: "GET", // *GET, POST, PUT, DELETE, etc.
//         mode: "cors", // no-cors, *cors, same-origin
// //        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
//         credentials: "include", // include, *same-origin, omit
//         headers: {
//           'X-Requested-With': 'XMLHttpRequest',
//           'X-Osit-Rid': this._rid
//           // 'Content-Type": 'application/json',
//           // 'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         redirect: "manual", // manual, *follow, error
//         referrerPolicy: "strict-origin-when-cross-origin", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
//         body: undefined, // string, FormData, Blob, BufferSource, or URLSearchParams
//         //body: JSON.stringify(data), // body data type must match "Content-Type" header
//       });
//       //console.log('response', response);

//       if (!response.ok){ // or check for response.status
//           //throw new Error(response.statusText);
//           this._error = true;
//           return null;
//       } 
//       json = await response.json(); // or .json() or whatever
//       // process body
//     } catch (err) {
//         //console.log(err)
//     }

//     return json;
//   },

  _getStorageValInterval: function(){
    return (window.localStorage !== undefined) ? parseInt(localStorage.getItem("mcInterval")) : 0;
  }

}    
